export default __webpack_public_path__ + "static/media/DOM.56223342.svg";